import { defineMessages } from 'react-intl';

export default defineMessages({
  color: {
    id: 'cboard.components.ColorSelect.color',
    defaultMessage: 'Color'
  },
  clearSelection: {
    id: 'cboard.components.ColorSelect.clearSelection',
    defaultMessage: 'Clear selection'
  },
  colorScheme: {
    id: 'cboard.components.ColorSelect.colorScheme',
    defaultMessage: 'Color Scheme'
  }
});
